export default __webpack_public_path__ + "static/media/case-hardening-icon.a2115a72.svg";